import React, { useState, useEffect } from "react";
import { fetchBlogCategories } from "./api";

const BCategory = () => {
    const [blogs, Setblogs] = useState([]);

    useEffect(() => {
        fetchBlogCategories()
            .then(data => Setblogs(data))
            .catch(err => console.error('Failed to fetch categories:', err));
    }, []);

    return (
        <div>
            {blogs.map(blog => (
                <div className="bcat" key={blog._id}>
                    <p>{blog.title}</p>
                </div>
            ))}
        </div>
    )
}

export default BCategory
